module.exports = __webpack_public_path__ + "static/nojaan-complete-f689004d7238ef0bab787af902b8c6e2.jpg";